import { render, staticRenderFns } from "./WorkorderInfo.vue?vue&type=template&id=bc4f9ef4&scoped=true&"
import script from "./WorkorderInfo.vue?vue&type=script&lang=js&"
export * from "./WorkorderInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorkorderInfo.vue?vue&type=style&index=0&id=bc4f9ef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4f9ef4",
  null
  
)

export default component.exports